<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="main">
            <Nav :title="state" />
            <div class="container">
                <div class="center-box">
                    <div class="text-box">
                        <h4>{{ dataList.xName }}</h4>
                        <span>发布时间：{{ dataList.showTime }}&nbsp;&nbsp; | &nbsp;&nbsp; 来源：{{ dataList.source }}</span>
                    </div>
                    <div class="content-box">
                        <div class="content-box-text" v-html="dataList.content" />
                        <div class="paging">
                            <div class="nav-paging">
                                <span v-if="dataList.nextId == 0" class="nothing">上一篇：无</span>
                                <span v-else>
                                    <RouterLink
                                        :key="dataList.nextId"
                                        :to="{name: 'navPoliciesDetails',query:{xId:dataList.nextId}}"
                                    >
                                        上一篇：{{ dataList.nextName }}
                                    </RouterLink>
                                </span>
                                <span class="nothing icon">|</span>
                                <span v-if="dataList.previousId == 0" class="nothing">下一篇：无</span>
                                <span v-else>
                                    <RouterLink
                                        :key="dataList.previousId"
                                        :to="{name: 'navPoliciesDetails',query:{xId:dataList.previousId}}"
                                    >下一篇：{{ dataList.previousName }}
                                    </RouterLink>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <NewsPolicies :policies-name="policiesNews" :data-list="NewsdataList" class="right-box-news" />
                    <NewsPolicies :policies-name="policiesRead" :recommend-list="RecommendList" class="right-box-read" />
                </div>
            </div>
        </div>
        <div v-else class="mobile">
            <div class="head">
                <img src="../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div>{{ dataList.xName }}</div>
            </div>
            <div v-html="dataList.content" />
        </div>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Nav from '@/layout/nav'
import NewsPolicies from '@/layout/policies/newsPolicies'
export default {
    components: {
        Nav,
        NewsPolicies
    },
    data() {
        return {
            policiesNews: {
                name: '最新动态',
                englishName: 'News Center'
            },
            policiesRead: {
                name: '推荐阅读',
                englishName: 'Recommend'
            },
            dataList: {},
            NewsdataList: [],
            RecommendList: [],
            state: 0,
            xId: '',
            bannerList: []
        }
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.dataRequest()
                this.Recommend()
                this.NewsDataRequest()
            }
        }
    },
    mounted() {
        console.log('this.$route.params.xId=====', this.$route.params.xId)
        if (this.$route.params.xId) {
            this.xId = this.$route.params.xId
        } else {
            this.xId = this.$route.query.xId
        }
        this.dataRequest()
        this.Recommend()
        this.NewsDataRequest()
    },
    beforeCreate() {
        document.querySelector('body').setAttribute(
            'style',
            'margin: 0 auto; width: 100%; background:rgba(244,245,247,1); overflow-x: hidden;height: 100%;')
    },
    methods: {
        dataRequest() {
            this.$api.get('news/xInfo', {
                params: {
                    xId: this.xId
                }
            }).then(res => {
                this.dataList = res.data
                this.state = res.data.navigationPath[0].np1Id
                const regex = new RegExp('<table', 'gi')
                this.dataList.content = this.dataList.content.replace(
                    regex,
                    '<table style="width: 100%"'
                )
                const regex1 = new RegExp('<img', 'gi')
                this.dataList.content = this.dataList.content.replace(
                    regex1,
                    '<img style="width: 100%;height: 100%;"'
                )
            })
        },
        NewsDataRequest() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 5,
                    offset: 0
                }
            }).then(res => {
                this.NewsdataList = res.data.list
            })
        },
        fallback() {
            this.$router.go(-1)
        },
        Recommend() {
            this.$api.get('news/xList', {
                params: {
                    cId: 1,
                    limit: 5,
                    offset: 0,
                    iscommend: 1
                }
            }).then(res => {
                this.RecommendList = res.data.list
            })
        }
    }

}

</script>

<style lang="scss" scoped>
.main {
    background: rgba(244, 245, 247, 1);
    .case-container {
        width: 1920px;
        margin: 0 auto;
        position: relative;
        top: 0;
        font-size: 0;
        .swiper-container {
            height: 100%;
            font-size: 0;
            .swiper-slide img {
                width: 100%;
                height: 100%;
                display: block;
                font-size: 0;
            }
            img {
                vertical-align: buttom;
                vertical-align: middle;
                vertical-align: top;
            }
            .swiper-slide { height: 10px; }
            .swiper-slide-active { height: auto; }
        }
        .new-list {
            position: absolute;
            top: 0;
            right: 380px;
            z-index: 99;
        }
        #map {
            width: 500px;
            height: 500px;
        }
        .bannar-box {
            width: 1920px;
            height: 360px;
        }
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .center-box {
            width: 808px;
            background-color: rgba(255, 255, 255, 1);
            margin-bottom: 60px;
            position: relative;
            .text-box {
                width: 728px;
                height: 190px;
                border-bottom: 1px solid  rgba(238, 238, 238, 1);
                margin: 0 auto;
                h4 {
                    font-size: 28px;
                    font-weight: bold;
                    color: rgba(71, 71, 71, 1);
                    line-height: 42px;
                    text-align: center;
                    width: 560px;
                    margin: 0 auto;
                    padding-top: 40px;
                }
                span {
                    font-size: 12px;
                    font-weight: 400;
                    display: block;
                    color: rgba(153, 153, 153, 1);
                    line-height: 24px;
                    text-align: center;
                    margin-top: 20px;
                }
            }
            .content-box {
                img {
                    width: 750px;
                    height: 320px;
                    margin: 0 auto;
                }
                .content-box-text {
                    padding: 34px;
                    padding-bottom: 80px;
                    ::v-deep p {
                        img {
                            max-width: 100%;
                        }
                    }
                }
                .paging {
                    width: 100%;
                    position: absolute;
                    bottom: 40px;
                    .nav-paging {
                        display: flex;
                        justify-content: space-around;
                        width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 24px;
                        .nothing {
                            color: #999;
                        }
                        .icon {
                            width: 4px;
                            margin: 0 10px;
                            color: #999;
                        }
                        span {
                            display: block;
                            width: 180px;
                            text-align: right;

                            /* 设置文本框大小 */
                            white-space: nowrap;

                            /* 设置内容不换行 */
                            text-overflow: ellipsis;

                            /* 设置文字超出文本框的内容显示成... */
                            overflow: hidden;
                            &:last-child {
                                text-align: left;
                            }
                            a {
                                text-decoration: none;
                                font-size: 12px;
                                font-weight: 400;
                                color: #273db4;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }
        }
        .right-box {
            margin-bottom: 60px;
            .right-box-news {
                width: 372px;
                height: 348px;
                background: rgba(255, 255, 255, 1);
            }
            .right-box-read {
                width: 372px;
                height: 348px;
                background: rgba(255, 255, 255, 1);
                margin-top: 20px;
            }
        }
    }
}
.mobile {
    padding: 0 15px;
    .head {
        height: 60px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
            width: 10px;
            height: 16px;
        }
        div {
            flex: 1;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            margin-left: 20px;
            color: #000;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            line-height: 16px;
        }
    }
}
</style>
